var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeft24Simple = function SvgLeft24Simple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.296 21.796c.439-.44.439-1.152 0-1.591L9.09 12l8.205-8.205a1.125 1.125 0 0 0-1.591-1.59l-9 9c-.44.439-.44 1.151 0 1.59l9 9c.439.44 1.151.44 1.59 0Z",
    fill: "#25282B"
  })));
};
export default SvgLeft24Simple;